import { Asterisk } from "lucide-react";

const ITEMS = [
  "Pure & Safe Water",
  "Engineered to Last",
  "5-Layer Protection",
  "Anti-Bacterial",
  "Self-Clean Technology",
  "UV Protected",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="relative overflow-hidden border-y border-avatar-ink/10 py-10">
      <div className="flex w-max animate-marquee gap-10 whitespace-nowrap will-change-transform">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-10">
            <span className="font-heading text-4xl font-bold uppercase tracking-tight text-avatar-ink md:text-6xl">
              {t}
            </span>
            <span className="text-avatar-red"><Asterisk size={40} strokeWidth={2.5} /></span>
          </div>
        ))}
      </div>
    </section>
  );
};
